import { ChangeEventHandler, useState } from 'react';

export function useImportQuizBySpreadsheetInputFile(
  onUploadFile: (file: File) => void
) {
  const [fileName, setFileName] = useState('');

  const onChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const firstFile = event.target.files[0];
    setFileName(firstFile.name ?? '');
    onUploadFile(firstFile);
  };

  return { fileName, onChange };
}
